import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormularioCurso from './FormularioCurso'
import { Container, Grid } from '@material-ui/core';
import AgregarSesiones from './AgregarSesiones';
import AgregarUsuarios from './AgregarUsuarios';
import { useLocalStorage } from '../hooks'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Ingresar Información del Curso', 'Crear Sesiones', 'Ingreso de asistentes'];
}


export default function CrearCurso() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [idCurso, setIdCurso] = React.useState(null);
  const steps = getSteps();

  const [name, setName] = useLocalStorage('idCurso', 'idCurso');

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  const handlerSaveCurso = (id) => {
    console.log("cursoAgregados")
    setName(id)
    setIdCurso(id)
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }
  const handleSaveSesiones = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }

  const getStepContent = (stepIndex, idCurso) => {
    console.log(idCurso);
    switch (stepIndex) {
      case 0:
        return <FormularioCurso onSaveCurso={handlerSaveCurso} />;
      case 1:
        return <AgregarSesiones onSaveNumSessiones={handleSaveSesiones} />
      case 2:
        return <AgregarUsuarios idCurso={idCurso} />
      default:
        return 'Unknown stepIndex';
    }
  }

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <Typography className={classes.instructions}>All steps completed</Typography>
            <Button onClick={handleReset}>Reset</Button>
          </div>
        ) : (
            <Container fixed>
              {getStepContent(activeStep, idCurso)}
              <Grid
                container
                style={{ paddingRight: 15 }}
                direction="row"
                justify="flex-end"
                alignItems="center">
                <Grid item>
                  <div>
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className={classes.backButton}>
                      Back
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleNext}>
                      {activeStep === steps.length - 1 ? 'Finish' : 'Continuar'}
                    </Button>
                  </div>
                </Grid>
              </Grid>

            </Container>
          )}
      </div>
    </div>
  );
}
